export default __webpack_public_path__ + "static/media/click3.e5f32edb.ogg";